export const extension = (filename) => {
    return filename.split('.').pop();
}

export const getIconClass = (ext) => {
    const supportTypes = {
        acc: ['acc', 'accdb', 'accde', 'accdr', 'accdt', 'ade', 'adn', 'adp', 'mam', 'maf', 'maq', 'mar', 'mat', 'mda', 'mdb', 'mde', 'mdf', 'mdn', 'mdt', 'mdw'],
        image: ['3fr', 'arw', 'bmp', 'cr2', 'crw', 'dcr', 'dng', 'erf', 'gif', 'jpe', 'jpeg', 'jpg', 'k25', 'kdc', 'mef', 'mos', 'mrw', 'nef', 'orf', 'pef', 'png', 'ptx', 'raf', 'raw', 'rw2', 'sr2', 'srf', 'tif', 'tiff', 'x3f', 'ufo', 'ico', 'heic', 'heif', 'svg'],
        audio: ['aac', 'ac3', 'aif', 'ape', 'cda', 'dts', 'flac', 'm4a', 'm4b', 'mid', 'mka', 'mp2', 'mp3', 'mpc', 'ogg', 'pcm', 'ra', 'wav', 'wma', 'mp1', 'mpa', 'ram', 'm4p', 'aiff', 'dsf', 'dff', 'm3u', 'wpl'],
        video: ['3g2', '3gp', 'ac3', 'amr', 'asf', 'avi', 'dat', 'divx', 'dvr-ms', 'ifo', 'm1v', 'm2t', 'm2ts', 'm2v', 'm4v', 'mkv', 'mov', 'mpe', 'mpeg', 'mpeg1', 'mpeg2', 'mpeg4', 'mpg', 'mp4', 'mts', 'ogv', 'qt', 'rm', 'rmvb', 'tp', 'trp', 'ts', 'vob', 'webm', 'wmv', 'xvid', 'vdr'],

        doc: ['doc', 'docx', 'rtf', 'wri', 'odt'],
        ppt: ['ppt', 'pps', 'ppsx', 'pptx', 'odp'],
        xls: ['xls', 'xla', 'xlam', 'xlb', 'xlc', 'xld', 'xlk', 'xll', 'xlm', 'xlsb', 'xlsm', 'xlsx', 'xlt', 'xltm', 'xlv', 'xlw', 'xltx', 'ods', 'ots', 'csv'],

        ai: ['ai'],
        psd: ['psd'],
        fla: ['fla'],
        pdf: ['pdf'],
        swf: ['swf', 'f4v', 'flv'],
        idn: ['idn', 'indd'],

        txt: ['diff', 'erl', 'json', 'lst', 'markdown', 'md', 'mdown', 'mkdn', 'out', 'patch', 'sml', 'txt'],
        htm: ['htm', 'html'],
        code: ['actproj', 'ad', 'akp', 'applescript', 'as', 'asax', 'asc', 'ascx', 'asm', 'asmx', 'asp', 'aspx', 'asr', 'as3', 'bat', 'c', 'cc', 'cmake', 'coffee', 'cpp', 'cs', 'css', 'cxx', 'erb', 'groovy', 'gvy', 'h', 'haml', 'hh', 'hpp', 'hxx', 'java', 'js', 'jsx', 'less', 'm', 'make', 'mhtml', 'ml', 'mm', 'php', 'pl', 'plist', 'properties', 'py', 'rb', 'sass', 'scala', 'scm', 'script', 'scss', 'sh', 'sql', 'swift', 'tsx', 'vb', 'vi', 'vim', 'xhtml', 'xml', 'xsd', 'xsl', 'yaml', 'yml'],
        bkpi: ['bkpi'],

        ttf: ['ttf', 'otf', 'ttc'],
        iso: ['iso', 'bin', 'daa', 'img', 'mds', 'nrg'],
        zip: ['zip', '7z', 'bz2', 'gz', 'rar', 'tar', 'tbz', 'tgz', 'txz', 'jar', 'lzh', 'rpm', 'xz', 'zipx'],
        exe: ['exe'],

        key: ['key'],
        pages: ['pages'],
        numbers: ['numbers'],

        folder: ['folder', 'dir'],
        synodoc: ['odoc'],
        synosheet: ['osheet'],
        synoslide: ['oslides'],
    }

    for (const key in supportTypes) {
        if (supportTypes[key].includes(ext)) {
        return key;
        }
    }

    return 'xxx'
};